/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDiagnosticResponseDto
 */
export interface AssetDiagnosticResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    status: AssetDiagnosticResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    ocppStatus?: AssetDiagnosticResponseDtoOcppStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    transferProtocol: AssetDiagnosticResponseDtoTransferProtocolEnum;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    ocppFileName?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    uploadFileId?: object | null;
    /**
     * True when status is UPLOADED and uploadFileId is set (S3 object may still be missing after retention).
     * @type {boolean}
     * @memberof AssetDiagnosticResponseDto
     */
    downloadable: boolean;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    retries?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    retryInterval?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    startTime?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    stopTime?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    requestedById?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticResponseDto
     */
    requestedAt: string;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    acknowledgedAt?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    uploadedAt?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    errorCode?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticResponseDto
     */
    errorMessage?: object | null;
}


/**
 * @export
 */
export const AssetDiagnosticResponseDtoStatusEnum = {
    Requested: 'REQUESTED',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Uploading: 'UPLOADING',
    Uploaded: 'UPLOADED',
    UploadFailed: 'UPLOAD_FAILED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED'
} as const;
export type AssetDiagnosticResponseDtoStatusEnum = typeof AssetDiagnosticResponseDtoStatusEnum[keyof typeof AssetDiagnosticResponseDtoStatusEnum];

/**
 * @export
 */
export const AssetDiagnosticResponseDtoOcppStatusEnum = {
    Idle: 'Idle',
    Uploading: 'Uploading',
    Uploaded: 'Uploaded',
    UploadFailed: 'UploadFailed'
} as const;
export type AssetDiagnosticResponseDtoOcppStatusEnum = typeof AssetDiagnosticResponseDtoOcppStatusEnum[keyof typeof AssetDiagnosticResponseDtoOcppStatusEnum];

/**
 * @export
 */
export const AssetDiagnosticResponseDtoTransferProtocolEnum = {
    Https: 'https',
    Ftps: 'ftps',
    Ftp: 'ftp'
} as const;
export type AssetDiagnosticResponseDtoTransferProtocolEnum = typeof AssetDiagnosticResponseDtoTransferProtocolEnum[keyof typeof AssetDiagnosticResponseDtoTransferProtocolEnum];


/**
 * Check if a given object implements the AssetDiagnosticResponseDto interface.
 */
export function instanceOfAssetDiagnosticResponseDto(value: object): value is AssetDiagnosticResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('transferProtocol' in value) || value['transferProtocol'] === undefined) return false;
    if (!('downloadable' in value) || value['downloadable'] === undefined) return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    return true;
}

export function AssetDiagnosticResponseDtoFromJSON(json: any): AssetDiagnosticResponseDto {
    return AssetDiagnosticResponseDtoFromJSONTyped(json, false);
}

export function AssetDiagnosticResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDiagnosticResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'assetId': json['assetId'],
        'status': json['status'],
        'ocppStatus': json['ocppStatus'] == null ? undefined : json['ocppStatus'],
        'transferProtocol': json['transferProtocol'],
        'ocppFileName': json['ocppFileName'] == null ? undefined : json['ocppFileName'],
        'uploadFileId': json['uploadFileId'] == null ? undefined : json['uploadFileId'],
        'downloadable': json['downloadable'],
        'retries': json['retries'] == null ? undefined : json['retries'],
        'retryInterval': json['retryInterval'] == null ? undefined : json['retryInterval'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'stopTime': json['stopTime'] == null ? undefined : json['stopTime'],
        'requestedById': json['requestedById'] == null ? undefined : json['requestedById'],
        'requestedAt': json['requestedAt'],
        'acknowledgedAt': json['acknowledgedAt'] == null ? undefined : json['acknowledgedAt'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : json['uploadedAt'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function AssetDiagnosticResponseDtoToJSON(json: any): AssetDiagnosticResponseDto {
    return AssetDiagnosticResponseDtoToJSONTyped(json, false);
}

export function AssetDiagnosticResponseDtoToJSONTyped(value?: AssetDiagnosticResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'assetId': value['assetId'],
        'status': value['status'],
        'ocppStatus': value['ocppStatus'],
        'transferProtocol': value['transferProtocol'],
        'ocppFileName': value['ocppFileName'],
        'uploadFileId': value['uploadFileId'],
        'downloadable': value['downloadable'],
        'retries': value['retries'],
        'retryInterval': value['retryInterval'],
        'startTime': value['startTime'],
        'stopTime': value['stopTime'],
        'requestedById': value['requestedById'],
        'requestedAt': value['requestedAt'],
        'acknowledgedAt': value['acknowledgedAt'],
        'uploadedAt': value['uploadedAt'],
        'errorCode': value['errorCode'],
        'errorMessage': value['errorMessage'],
    };
}

